import PropTypes from 'prop-types';
import React from 'react';

interface StageVisualizationProps {
  name: string;
  height: number;
  width: number;
  icon?: JSX.Element | null;
}

export default function StageVisualization({
  name,
  height,
  width,
  icon,
}: StageVisualizationProps): JSX.Element {
  return (
    <div className="workflowVisualization-stage" style={{width, height}}>
      <div className="workflowVisualization-stage-header">
        <span className="workflowVisualization-stage-name">{name}</span>
        {icon}
      </div>
    </div>
  );
}

StageVisualization.propTypes = {
  name: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  icon: PropTypes.node,
};
